import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

/**
 * Tooltip is rendered using Portals which requires special syntax.
 * See explanation - https://mui.com/material-ui/guides/interoperability/#portals
 */
export const TooltipRoot = styled(
  ({ className, ...props }) => (
    <Tooltip classes={{ popper: `${className}` }} {...props} />
  ),
  {
    name: 'AFTooltip',
    shouldForwardProp: prop => prop !== 'variant' && prop !== 'maxWidth'
  }
)(({ theme, variant, maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...(variant === 'info' && {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      padding: theme.spacing(1.5, 2),
      maxWidth,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.shadows[4],
      '& .MuiTypography-h3': {
        marginBottom: 4
      }
    })
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.text.primary,
    ...(variant === 'info' && {
      color: theme.palette.common.white,
      '&:before': {
        outline: `1px solid ${theme.palette.divider}`
      }
    })
  }
}));
